<template>
<div class="chapter">
<div class="inner_page">
<p class="copyt"><img alt="image" src="images/cop.png"/></p>
<p class="copyt"><a id="page_iv"><i>This book is a publication of</i></a></p><a id="page_iv">
<p class="copyt">Indiana University Press<br/>Office of Scholarly Publishing<br/>Herman B Wells Library 350<br/>1320 East 10th Street<br/>Bloomington, Indiana 47405 <span class="small">USA</span></p>
</a><p class="copyt"><a id="page_iv"></a><a href="http://iupress.org" target="_blank">iupress.org</a></p>
<p class="copyt"><i>Indiana Review</i></p>
<p class="copy">Bloomington, Indiana</p>
<p class="copyt">© 2020 by Jennie Maria Malboeuf<br/>All rights reserved</p>
<p class="copyt">No part of this book may be reproduced or utilized in any form or by any means, electronic or mechanical, including photocopying and recording, or by any information storage and retrieval system, without permission in writing from the publisher. The paper used in this publication meets the minimum requirements of the American National Standard for Information Sciences—Permanence of Paper for Printed Library Materials, <span class="small">ANSI Z</span>39.48–1992.</p>
<p class="copyt"><i>Manufactured in the United States of America</i></p>
<p class="copyt">First printing 2020</p>
<p class="copyt">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyt">Names: Malboeuf, Jennie Maria, author.</p>
<p class="copy">Title: God had a body: poems / Jennie Maria Malboeuf.</p>
<p class="copy">Description: Bloomington, Indiana: Indiana University Press/Indiana Review, [2020] | Series: Blue Light Books.</p>
<p class="copy">Identifiers: LCCN 2019021139 (print) | LCCN 2019021533 (ebook) | ISBN 9780253047267 (ebook) | ISBN 9780253047243 (pbk.: alk. paper)</p>
<p class="copy">Classification: LCC PS3613.A4326 (ebook) | LCC PS3613.A4326 A6 2020 (print) | DDC 811/.6—dc23</p>
<p class="copy">LC record available at <a href="https://lccn.loc.gov/2019021139" target="_blank">https://lccn.loc.gov/2019021139</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Copyright.vue?3e11c336